var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlaceholderRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.2689 14.5065C16.3314 16.4738 14.3244 17.8333 12 17.8333C10.2476 17.8333 8.67572 17.0606 7.60643 15.8374L10.5102 11.3798L12.6263 15.1898L15.3 12.5976L17.2689 14.5065Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8333 12C17.8333 12.4433 17.7839 12.875 17.6902 13.29L15.3 10.9726L12.9071 13.2926L10.5898 9.12021L6.88522 14.8071C6.42721 13.9743 6.16667 13.0176 6.16667 12C6.16667 8.77834 8.77834 6.16667 12 6.16667C15.2217 6.16667 17.8333 8.77834 17.8333 12ZM13.75 8.20833C13.75 8.69158 13.3583 9.08333 12.875 9.08333C12.3917 9.08333 12 8.69158 12 8.20833C12 7.72508 12.3917 7.33333 12.875 7.33333C13.3583 7.33333 13.75 7.72508 13.75 8.20833Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlaceholderRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/placeholder-regular.fea3dd63.svg";
export { ForwardRef as ReactComponent };